import Swiper from 'swiper/bundle';

document.addEventListener("DOMContentLoaded", function(event) {

    var swiper1 = new Swiper('.js-about-slider', {
        loop: true,
        autoplay: false,
        spaceBetween: 0,
        slidesPerView: 1,
        disableOnInteraction: true,
        pagination: {
            el: '.swiper-pagination',
            type: "fraction",
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            574: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
        },
    });
    let progressSlider = document.querySelector('.js-const-progress-slider');
    if (progressSlider) {
        setTimeout(() => {
            let years = document.querySelectorAll('.js-year-item');
            let months = document.querySelectorAll('.js-month-item');
            let slideElements = document.querySelectorAll('.js-progress-slide');
            let slideCount = slideElements.length;
            let swiper1 = new Swiper('.js-const-progress-slider', {
                loop: true,
                autoplay: false,
                slidesPerView: 1,
                disableOnInteraction: true,
                autoHeight: true,
                pagination: {
                    el: '.swiper-pagination',
                    type: "fraction",
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                on: {
                    slideChange: function(swiper) {
                        let index = swiper.activeIndex;
                        if (!index) index = slideCount;
                        if (index > slideCount) index = 1;
                        let slide = document.querySelector(`.js-progress-slide-${index}`);
                        if (!slide) return;
                        let year = slide.dataset.year;
                        let month = slide.dataset.month;
                        years.forEach(y => {
                            if (y.dataset.year == year) {
                                y.classList.add('-is-active');
                            } else {
                                y.classList.remove('-is-active');
                            }
                        });
                        months.forEach(m => {
                            if (m.dataset.year == year) {
                                m.classList.remove('d-none');
                            } else {
                                m.classList.add('d-none');
                            }
                            if (m.dataset.month == month) {
                                m.classList.add('-is-active');
                            } else {
                                m.classList.remove('-is-active');
                            }
                        })
                    },
                },
            });
            document.addEventListener('click', function(event) {
                let yearElement = event.target.closest('.js-year-item');
                if (yearElement) {
                    let year = yearElement.dataset.year;
                    let index = 0;
                    let i = 1;
                    slideElements.forEach(e => {
                        if (!index && e.dataset.year == year) index = i;
                        i++;
                    })
                    swiper1.slideTo(index);
                }
                let monthElement = event.target.closest('.js-month-item');
                if (monthElement) {
                    let month = monthElement.dataset.month;
                    let index = 0;
                    let i = 1;
                    slideElements.forEach(e => {
                        if (!index && e.dataset.month == month) index = i;
                        i++;
                    })
                    swiper1.slideTo(index);
                }
            });
        }, 1000);

    }



    /* $(".swiper-container").hover(function() {
        (this).swiper.autoplay.stop();
    }, function() {
        (this).swiper.autoplay.start();
    }); */
});
